import type { FaireProductEntity } from "../../entity_types/product";

export const p_4zxgduupjt: FaireProductEntity = {
  token: "p_4zxgduupjt",
  type: "product",
  name: "Community Garden Candle",
  brandToken: "b_jx5r7yrney",
  brandName: "Loam Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/4498db7ee8482ee2f78eeabdbacb1c53a4e26cd0f7a585de1a96a6583ffb1cb6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/694aaf9ec0f78ef3d47abd94b59abeb2357116f1bbe240175e2ef5c271cda072.jpeg",
    "https://cdn.faire.com/fastly/18e58a3c2a8328ff8d8fba66f3262279a6b595513674ef2d89beeb6acba8a8df.jpeg",
    "https://cdn.faire.com/fastly/e5cac789a53a9ccb7852badcaa3af62b953e6ef4ac176c9db54ae78786d05656.jpeg",
  ],
  priceDollars: 16.5,
  description:
    "Scent notes: tomato leaf, green fig, marigold and mandarin\n\nFreshly pruned tomato leaves, fig nectar warmed by the July sun, interplanted marigolds, a job well done. Vegetal greens and zingy fruits capture the animated and harmonious hum of a California community garden in full bloom.\n\nThe vibe: green, fresh, bright, earthy, zesty\n\nEvery candle is crafted in small batches with coconut soy wax and 100% cotton wicks. Loam candles are always paraben, paraffin, petroleum, and phthalate-free.",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:26.486Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
